import { SpaceType } from '@onesource/schemas';
import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { ReviewSearchSchema, TeacherReviewPage } from 'src/features/community-hub/components/form-review';
import { ModuleDetailView } from 'src/features/community-hub/components/module-detail-view';
import { MyAnalyticsPage } from 'src/features/community-hub/components/my-analytics';
import { z } from 'zod';

/**
 * Sub-space detail. Path: /programs/{programSlug}/{moduleSlug}
 * A content module renders the lesson accordion; a "My Analytics" sub-space
 * renders the member's requirements; a Teacher Review sub-space renders the
 * teacher's review queue. Both share the slug resolution and the
 * content-route context provided by the layout route.
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/')({
  // A Teacher Review sub-space keeps its view and filters in the URL too.
  validateSearch: z.object({ sectionId: z.string().optional().catch(undefined) }).merge(ReviewSearchSchema),
  component: ModuleDetailRoute,
});

const layoutRoute = getRouteApi('/_protected/programs/$programSlug/$moduleSlug');

function ModuleDetailRoute() {
  const { sectionId, ...reviewSearch } = Route.useSearch();
  const navigate = Route.useNavigate();
  const resolved = layoutRoute.useLoaderData();
  if (resolved.module?.spaceType === SpaceType.ANALYTICS) {
    return <MyAnalyticsPage />;
  }
  if (resolved.module?.spaceType === SpaceType.REVIEW) {
    return (
      <TeacherReviewPage
        search={reviewSearch}
        onSearchChange={search => navigate({ search, replace: true, resetScroll: false })}
      />
    );
  }
  return <ModuleDetailView expandedSectionId={sectionId} />;
}
